/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { ErrorMessageTexts } from './constants';
/**
 * Extra API layer for v2 and v3 compatibility
 *
 * @param props - tmp data and error returned straight from gql query or mutation
 * @param responseHandler - success response handler
 * @param errorsHandler - error response handler
 * @returns memoized response and errors
 */
export const useApiResponse = ({ data, errors, loading, error }, responseHandler, errorsHandler, errorMessageHandler) => {
    const [errorMessage, setErrorMessage] = useState('');
    useEffect(() => {
        if (data && responseHandler) {
            responseHandler(data);
        }
    }, [data]);
    useEffect(() => {
        const errorToUse = errors || error;
        if (errorToUse) {
            if (errorsHandler)
                errorsHandler(errorToUse);
            if ('message' in errorToUse) {
                const errMessage = ErrorMessageTexts[errorToUse['message']] ||
                    ErrorMessageTexts.DEFAULT;
                setErrorMessage(errMessage);
                errorMessageHandler?.(errMessage);
            }
        }
    }, [errors, error]);
    const clearErrorMessage = () => {
        setErrorMessage('');
    };
    return {
        errors: errors || error,
        errorMessage,
        response: data,
        loading: Boolean(loading),
        clearErrorMessage,
    };
    // NOTE: v3 functionality
    // const { listenToResponse } = useApiResponseContext();
    // return {
    //  response: listenToResponse(data?.jobId),
    //  error,
    // };
};
//# sourceMappingURL=useApiResponse.js.map